// @flow
import * as React from 'react'
import tw from 'tailwind-styled-components'

type Props = {
  children: React.Node,
  $inline?: boolean,
}

const Title: React.ComponentType<Props> = tw.h1`
  text-4xl
  font-medium
  text-gray-700

  ${(props: Props) =>
    props.$inline
      ? `
    inline
    mr-3
  `
      : ''}
`

export default Title
